import { gql, useQuery } from "@apollo/client";
import { ENABLE_FTV2_SUPPORT, SessionKey } from "../../common/constants";
import { getNodeEnvironment } from "../../common/nodeEnvironment";
export const GET_CURRENT_USER = gql `
  query GetCurrentUser {
    currentUser {
      id
      emailAddress
      firstName
      lastName
      status
      userRole
      auditMetadata {
        createdAt
      }
      gandalfDetails {
        audiencePath
        vibeId
      }
    }
  }
`;
export const GET_SUBSCRIPTION_REQUEST_BY_AWS_ACCOUNT_ID = gql `
  query subscriptionRequestByAWSAccountId ($awsAccountId: ID!) {
    subscriptionRequestByAWSAccountId (id: $awsAccountId) {
      id
      seats
      submitted_by
      order_date
      order_number
      subscription_status
      start_date
      end_date
    }
  }
`;
export const GET_SUBSCRIPTION_REQUEST_BY_USER_ID = gql `
  query subscriptionRequestByUserId ($userId: ID!) {
    subscriptionRequestsByUserId(userId: $userId) {
      nodes {
        id
        createdAt
        createdBy
        endCustomerCompanyName
        endCustomerCountry
        status
        subscriptionEndDate
        subscriptionStartDate
        userId
        pricePerSeat
        numberOfSeats
        discountPercentage
        lastName
        firstName
        linkedAccountId
        signInMethod
        orderId
        partnerRequest
        awsEndUserAccount
        parentRequestId
        subscriptionRequestType
      }
    }
  }
`;
export const GET_SUBSCRIPTION_REQUEST_BY_VIBE_ID = gql `
  query subscriptionRequestByVibeId ($vibeId: ID!) {
    subscriptionRequestsByVibeId(vibeId: $vibeId) {
      nodes {
        id
        createdAt
        createdBy
        endCustomerCompanyName
        endCustomerCountry
        status
        subscriptionEndDate
        subscriptionStartDate
        userId
        pricePerSeat
        numberOfSeats
        discountPercentage
        lastName
        firstName
        linkedAccountId
        signInMethod
        orderId
        partnerRequest
        awsEndUserAccount
        parentRequestId
        subscriptionRequestType
      }
    }
  }
`;
export const GET_SUBSCRIPTION_REQUEST_BY_SUBSCRIPTION_ID = gql `
  query subscriptionRequestById($id: ID!) {
    subscriptionRequestById(id: $id) {
      id
      autoRenewal
      createdAt
      createdBy
      customerCountry
      endCustomerCompanyName
      endCustomerCountry
      businessEmail
      companyName
      status
      subscriptionEndDate
      subscriptionStartDate
      userId
      pricePerSeat
      numberOfSeats
      discountPercentage
      distributionSellerName
      lastName
      firstName
      linkedAccountId
      signInMethod
      orderId
      partnerRequest
      awsEndUserAccount
      parentRequestId
      learningAdministrators {
        firstName
        lastName
        email
      }
    }
  }
`;
export const GET_SPMS_ID_VALIDATION = gql `
  query spmsIdValidation ($id: Int!) {
    validateATPUserBySPMSId(id: $id)
  }
`;
export const GET_OFFER_PRICE_FOR_ACCOUNT = gql `
  query getPayerAccountOfferPrice ($input: PayerAccountOfferPriceInput!) {
    getPayerAccountOfferPrice(
      input: $input
    ) {
      payerAccountId
      pricePerSeat
      pricePerSeatMap {
        pricePerSeat
        territory
      }
      resellAuthorizedTerritories
      discountList {
        percentageDiscount
        seatThreshold
      }
      requesterType
    }
  }
`;
export const GET_OFFER_PRICE_FOR_ACCOUNT_WITH_FTV2_SUPPORT = gql `
  query getPayerAccountOfferPrice ($input: PayerAccountOfferPriceInput!) {
    getPayerAccountOfferPrice(
      input: $input
    ) {
      payerAccountId
      pricePerSeat
      pricePerSeatMap {
        pricePerSeat
        territory
      }
      resellAuthorizedTerritories
      discountList {
        percentageDiscount
        seatThreshold
      }
      requesterType
      accountPlanType
    }
  }
`;
export const useGetOfferPriceForAccount = (accountId, userId, userEmail, spmsId, vibeId) => {
    const variables = {
        input: {
            userEmail,
            accountId,
            userId,
            partnerRequest: spmsId ? true : false,
            vibeId
        }
    };
    try {
        // If FTv2 support enabled, use the query with accountPlanType in response
        if (ENABLE_FTV2_SUPPORT[getNodeEnvironment()]) {
            return useQuery(GET_OFFER_PRICE_FOR_ACCOUNT_WITH_FTV2_SUPPORT, {
                variables
            });
        }
    }
    catch (err) {
        // If an error occurs in the FTv2 supported query then fall back to the regular query
        return useQuery(GET_OFFER_PRICE_FOR_ACCOUNT, {
            variables
        });
    }
    // If FTv2 support not enabled, use the regular query
    return useQuery(GET_OFFER_PRICE_FOR_ACCOUNT, {
        variables
    });
};
export const useGetCurrentUser = () => {
    return useQuery(GET_CURRENT_USER, {});
};
export const useSubscriptionRequestByUserId = (userId) => {
    return useQuery(GET_SUBSCRIPTION_REQUEST_BY_USER_ID, {
        variables: { userId }
    });
};
export const useSubscriptionRequestByVibeId = (vibeId) => {
    return useQuery(GET_SUBSCRIPTION_REQUEST_BY_VIBE_ID, {
        variables: { vibeId }
    });
};
export const validateATPUserBySPMSId = (spmsId) => {
    return useQuery(GET_SPMS_ID_VALIDATION, {
        variables: { id: spmsId }
    });
};
export const getSubscriptionRequestBySubscriptionId = (subscriptionId) => {
    return useQuery(GET_SUBSCRIPTION_REQUEST_BY_SUBSCRIPTION_ID, {
        variables: { id: subscriptionId }
    });
};
//checks if the user is an ATP
export const useAWSAccountValidation = (userEmail, accountId, userId, successCallback, errorCallback) => {
    const isPartnerRequest = !!sessionStorage.getItem(SessionKey.IS_AMAZON_TRAINING_PARTNER);
    const skip = !accountId;
    return useQuery(GET_OFFER_PRICE_FOR_ACCOUNT, {
        skip: skip,
        variables: { input: {
                userEmail: userEmail,
                accountId: accountId,
                userId: userId,
                partnerRequest: isPartnerRequest
            } },
        onCompleted: (data) => {
            successCallback(data?.validateATPUserBySPMSId);
        },
        onError: (error) => {
            errorCallback(error);
        },
    });
};
